export default {"src":"/_next/static/media/feeding-guidelines.80912418.svg","height":70,"width":69,"blurWidth":0,"blurHeight":0};